// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-flex-items-center[data-v-133ddb89] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.label-width[data-v-133ddb89] {\n  float: left;\n  width: 25%;\n}\n.input-width[data-v-133ddb89] {\n  float: left;\n  width: 75%;\n}", ""]);
// Exports
module.exports = exports;
